import { instance } from '@/utils/http.js'
import Vue from 'vue'

// 获取学生科目
export const getStudentSubject = function () {
  return instance({
    url: '/api/v1/cp/subject_list',
    method: 'get',
  })
}

//获取所有科目
// export const getAllSubject = function (params) {
//   return instance({
//     url: '/api/v1/cp/subject_list',
//     method: 'get',
//     params
//   })
// }

//获取排名
export const getRankList = function (params) {
  return instance({
    url: '/api/v1/user/userRanking',
    method: 'get',
    params
  })
}


export const getUserInfo = function (params) {
  return instance({
    url: '/api/v1/user/user_info',
    method: 'get',
    params
  })
}
export const getSubmitGoalCollege = function (data) {
  return instance({
    url: '/api/v1/user/submitGoalCollege',
    method: 'post',
    data
  })
}

export const submitCollegeTarget = function (data) {
  return instance({
    url: '/api/v1/user/submitGoalCollege',
    method: 'post',
    data
  })
}

export const getCollegeList = function (params) {
  return instance({
    url: '/api/v1/getGoalCollegeList',
    method: 'get',
    params
  })
}